import selector from './selector/selector.module'
import groupselector from './group-selector/group-selector.module'
import comparison from './comparison/comparison.module'
import checkout from './checkout/checkout.module'
import details from './details/details.module'

const module = angular.module('mpa.pages', [selector, checkout, comparison, details, groupselector])

export default module.name
